module.exports = __webpack_public_path__ + "a8a10a3e/img/pdf-icon.79f04a36.svg";